"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Button = function Button(_ref) {
  var left = _ref.left,
      className = _ref.className,
      onPress = _ref.onPress,
      callback = _ref.callback,
      ArrowCustom = _ref.ArrowCustom,
      classes = _ref.classes;

  var handleOnPress = function handleOnPress() {
    onPress(); // eslint-disable-next-line no-unused-expressions

    callback && callback();
  };

  return ArrowCustom ? _react["default"].createElement(ArrowCustom, {
    className: "".concat(classes.arrowStyle, " ").concat(className),
    onClick: handleOnPress
  }) : _react["default"].createElement(_IconButton["default"], {
    className: "".concat(classes.arrowStyle, "  ").concat(className),
    onClick: handleOnPress
  }, left ? _react["default"].createElement(_KeyboardArrowLeft["default"], null) : _react["default"].createElement(_KeyboardArrowRight["default"], null));
};

Button.propTypes = {
  left: _propTypes.bool,
  onPress: _propTypes.func,
  callback: _propTypes.func,
  className: _propTypes.string,
  ArrowCustom: _propTypes.node,
  classes: _propTypes.any // eslint-disable-line react/forbid-prop-types

};

var _default = (0, _react.memo)(Button);

exports["default"] = _default;